import React, { useState } from 'react';
import './CommonStyles.css';
import { Info, Download, ChevronDown, Plus, Search, Trash2, Edit3, Printer, FileSpreadsheet, FileText, LayoutGrid } from 'lucide-react';

const TaxRates = () => {
    const [showAddModal, setShowAddModal] = useState(false);
    const [showAddGroupModal, setShowAddGroupModal] = useState(false);
    const [showExportDropdown, setShowExportDropdown] = useState(false);
    const [showGroupExportDropdown, setShowGroupExportDropdown] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [groupSearchQuery, setGroupSearchQuery] = useState('');

    const [taxRates, setTaxRates] = useState([
        { id: 1, name: 'Beer 1% (For tax group only)', rate: '1.00' },
        { id: 2, name: 'CIGARETTES (For tax group only)', rate: '0.00' },
        { id: 3, name: 'Food (For tax group only)', rate: '0.13' },
        { id: 4, name: 'NoTax (For tax group only)', rate: '0.00' },
        { id: 5, name: 'SalesTax (For tax group only)', rate: '7.50' },
        { id: 6, name: 'wine and liquor single (For tax group only)', rate: '3.00' }
    ]);

    const [taxGroups, setTaxGroups] = useState([
        { id: 1, name: 'Group Tax 1', subTaxes: 'Food, SalesTax' }
    ]);

    const renderAddModal = () => (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
            <div style={{ background: '#fff', borderRadius: '8px', width: '600px', maxWidth: '95vw', overflow: 'hidden', boxShadow: '0 10px 25px rgba(0,0,0,0.2)' }}>
                {/* Modal Header */}
                <div style={{ padding: '1.25rem 1.5rem', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h3 style={{ margin: 0, fontSize: '1.25rem', color: '#1e293b', fontWeight: '600' }}>Add Tax Rate</h3>
                    <button onClick={() => setShowAddModal(false)} style={{ background: 'none', border: 'none', color: '#94a3b8', cursor: 'pointer', fontSize: '1.5rem', lineHeight: '1' }}>&times;</button>
                </div>

                {/* Modal Body */}
                <div style={{ padding: '1.5rem' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
                        <div>
                            <label style={{ display: 'block', fontWeight: '700', color: '#1e293b', marginBottom: '0.4rem' }}>Name:*</label>
                            <input type="text" placeholder="Name" style={{ width: '100%', padding: '0.6rem 0.8rem', border: '1px solid #cbd5e1', borderRadius: '6px' }} />
                        </div>

                        <div>
                            <label style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', fontWeight: '700', color: '#1e293b', marginBottom: '0.4rem' }}>
                                Tax Rate %:* <Info size={16} style={{ color: '#00d1ff' }} />
                            </label>
                            <input type="text" placeholder="" style={{ width: '100%', padding: '0.6rem 0.8rem', border: '1px solid #cbd5e1', borderRadius: '6px' }} />
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                            <input type="checkbox" id="taxGroupOnly" />
                            <label htmlFor="taxGroupOnly" style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', fontWeight: '600', color: '#1e293b' }}>
                                For tax group only <Info size={16} style={{ color: '#00d1ff' }} />
                            </label>
                        </div>
                    </div>
                </div>

                {/* Modal Footer */}
                <div style={{ padding: '1.5rem', borderTop: 'none', display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                    <button style={{ background: '#4c00ff', color: 'white', border: 'none', borderRadius: '6px', padding: '0.6rem 2rem', fontWeight: '600', cursor: 'pointer', minWidth: '90px' }}>
                        Save
                    </button>
                    <button onClick={() => setShowAddModal(false)} style={{ background: '#2d3748', color: 'white', border: 'none', borderRadius: '6px', padding: '0.6rem 2rem', fontWeight: '600', cursor: 'pointer', minWidth: '90px' }}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );

    const renderAddGroupModal = () => (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
            <div style={{ background: '#fff', borderRadius: '8px', width: '500px', maxWidth: '95vw', overflow: 'hidden', boxShadow: '0 10px 25px rgba(0,0,0,0.2)' }}>
                {/* Modal Header */}
                <div style={{ padding: '1.25rem 1.5rem', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h3 style={{ margin: 0, fontSize: '1.25rem', color: '#1e293b', fontWeight: '600' }}>Add tax group</h3>
                    <button onClick={() => setShowAddGroupModal(false)} style={{ background: 'none', border: 'none', color: '#94a3b8', cursor: 'pointer', fontSize: '1.5rem', lineHeight: '1' }}>&times;</button>
                </div>

                {/* Modal Body */}
                <div style={{ padding: '1.5rem' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
                        <div>
                            <label style={{ display: 'block', fontWeight: '700', color: '#1e293b', marginBottom: '0.4rem' }}>Name:*</label>
                            <input type="text" placeholder="Name" style={{ width: '100%', padding: '0.6rem 0.8rem', border: '1px solid #cbd5e1', borderRadius: '6px' }} />
                        </div>

                        <div>
                            <label style={{ display: 'block', fontWeight: '700', color: '#1e293b', marginBottom: '0.4rem' }}>Sub taxes:*</label>
                            <div style={{ maxHeight: '200px', overflowY: 'auto', border: '1px solid #cbd5e1', borderRadius: '6px', padding: '0.5rem' }}>
                                {[
                                    'Beer 1%', 'Food', 'SalesTax',
                                    'wine and liquor single', 'NoTax', 'CIGARETTES'
                                ].map((tax, idx) => (
                                    <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.4rem 0' }}>
                                        <input type="checkbox" id={`tax-${idx}`} />
                                        <label htmlFor={`tax-${idx}`} style={{ fontSize: '0.9rem', color: '#4a5568' }}>{tax}</label>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Modal Footer */}
                <div style={{ padding: '1.5rem', borderTop: 'none', display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                    <button style={{ background: '#4c00ff', color: 'white', border: 'none', borderRadius: '6px', padding: '0.6rem 2rem', fontWeight: '600', cursor: 'pointer', minWidth: '90px' }}>
                        Save
                    </button>
                    <button onClick={() => setShowAddGroupModal(false)} style={{ background: '#2d3748', color: 'white', border: 'none', borderRadius: '6px', padding: '0.6rem 2rem', fontWeight: '600', cursor: 'pointer', minWidth: '90px' }}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );

    return (
        <div style={{ padding: '0', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <div style={{ display: 'flex', alignItems: 'baseline', gap: '0.5rem', marginBottom: '0.5rem' }}>
                <h2 style={{ margin: 0, fontSize: '1.5rem', fontWeight: '700', color: '#1e293b' }}>Tax Rates</h2>
                <span style={{ color: '#64748b', fontSize: '0.9rem' }}>Manage your tax rates</span>
            </div>

            <div style={{ background: '#fff', borderRadius: '8px', border: '1px solid #e2e8f0', overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
                {/* Header Row */}
                <div style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid #e2e8f0', padding: '1.25rem' }}>
                    <h3 style={{ margin: 0, fontSize: '1rem', color: '#1e293b', fontWeight: '600' }}>All your tax rates</h3>
                    <button
                        onClick={() => setShowAddModal(true)}
                        style={{ marginLeft: 'auto', background: '#4c00ff', color: 'white', border: 'none', borderRadius: '20px', padding: '0.5rem 1.5rem', fontWeight: '600', fontSize: '0.875rem', display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}
                    >
                        <Plus size={18} /> Add
                    </button>
                </div>

                <div style={{ padding: '1.5rem' }}>
                    {/* Controls Row */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem', flexWrap: 'wrap', gap: '1rem' }}>
                        <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                            <span style={{ fontSize: '0.9rem', color: '#64748b' }}>Show</span>
                            <select style={{ padding: '0.3rem 0.5rem', border: '1px solid #e2e8f0', borderRadius: '4px', fontSize: '0.85rem' }}>
                                <option>25</option>
                                <option>50</option>
                                <option>100</option>
                            </select>
                            <span style={{ fontSize: '0.9rem', color: '#64748b' }}>entries</span>
                        </div>

                        <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
                            <div style={{ position: 'relative' }}>
                                <button
                                    onClick={() => setShowExportDropdown(!showExportDropdown)}
                                    style={{ background: '#fff', color: '#64748b', border: '1px solid #e2e8f0', padding: '0.5rem 1rem', borderRadius: '6px', display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.875rem', fontWeight: '600', cursor: 'pointer' }}
                                >
                                    <Download size={16} /> Export <ChevronDown size={14} />
                                </button>
                                {showExportDropdown && (
                                    <div style={{ position: 'absolute', top: '100%', right: 0, marginTop: '0.5rem', background: '#fff', border: '1px solid #e2e8f0', borderRadius: '6px', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)', zIndex: 50, minWidth: '180px', padding: '0.5rem 0' }}>
                                        <button style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', width: '100%', padding: '0.6rem 1rem', border: 'none', background: 'none', textAlign: 'left', fontSize: '0.85rem', color: '#334155', cursor: 'pointer' }}>
                                            <FileSpreadsheet size={16} color="#10b981" /> Export CSV
                                        </button>
                                        <button style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', width: '100%', padding: '0.6rem 1rem', border: 'none', background: 'none', textAlign: 'left', fontSize: '0.85rem', color: '#334155', cursor: 'pointer' }}>
                                            <FileSpreadsheet size={16} color="#3b82f6" /> Export Excel
                                        </button>
                                        <button style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', width: '100%', padding: '0.6rem 1rem', border: 'none', background: 'none', textAlign: 'left', fontSize: '0.85rem', color: '#334155', cursor: 'pointer' }}>
                                            <Printer size={16} color="#6366f1" /> Print
                                        </button>
                                        <button style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', width: '100%', padding: '0.6rem 1rem', border: 'none', background: 'none', textAlign: 'left', fontSize: '0.85rem', color: '#334155', cursor: 'pointer' }}>
                                            <LayoutGrid size={16} color="#8b5cf6" /> Column visibility
                                        </button>
                                        <button style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', width: '100%', padding: '0.6rem 1rem', border: 'none', background: 'none', textAlign: 'left', fontSize: '0.85rem', color: '#334155', cursor: 'pointer' }}>
                                            <FileText size={16} color="#ef4444" /> Export PDF
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                            <span style={{ fontSize: '0.9rem', color: '#64748b' }}>Search:</span>
                            <input
                                type="text"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                style={{ padding: '0.4rem 0.8rem', border: '1px solid #cbd5e1', borderRadius: '4px', fontSize: '0.85rem', outline: 'none' }}
                            />
                        </div>
                    </div>

                    {/* Table */}
                    <div style={{ overflowX: 'auto' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '0.9rem' }}>
                            <thead>
                                <tr style={{ borderTop: '1px solid #e2e8f0', borderBottom: '1px solid #e2e8f0' }}>
                                    <th style={{ padding: '1rem', color: '#1e293b', fontWeight: '700' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                            Name
                                            <div style={{ display: 'flex', flexDirection: 'column', fontSize: '10px' }}>▲▼</div>
                                        </div>
                                    </th>
                                    <th style={{ padding: '1rem', color: '#1e293b', fontWeight: '700' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                            Tax Rate %
                                            <div style={{ display: 'flex', flexDirection: 'column', fontSize: '10px' }}>▲▼</div>
                                        </div>
                                    </th>
                                    <th style={{ padding: '1rem', color: '#1e293b', fontWeight: '700' }}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {taxRates.map((rate) => (
                                    <tr key={rate.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                                        <td style={{ padding: '1rem', color: '#4a5568' }}>{rate.name}</td>
                                        <td style={{ padding: '1rem', color: '#4a5568' }}>{rate.rate}</td>
                                        <td style={{ padding: '0.75rem 1rem' }}>
                                            <div style={{ display: 'flex', gap: '0.5rem' }}>
                                                <button style={{ background: '#fff', color: '#6200ea', border: '1px solid #6200ea', padding: '0.3rem 0.8rem', borderRadius: '6px', fontSize: '0.8rem', display: 'flex', alignItems: 'center', gap: '0.3rem', fontWeight: '600', cursor: 'pointer' }}>
                                                    <Edit3 size={14} /> Edit
                                                </button>
                                                <button style={{ background: '#fff', color: '#ff5252', border: '1px solid #ff5252', padding: '0.3rem 0.8rem', borderRadius: '6px', fontSize: '0.8rem', display: 'flex', alignItems: 'center', gap: '0.3rem', fontWeight: '600', cursor: 'pointer' }}>
                                                    <Trash2 size={14} /> Delete
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination Info */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '1.5rem' }}>
                        <span style={{ fontSize: '0.9rem', color: '#4a5568' }}>Showing 1 to 6 of 6 entries</span>
                        <div style={{ display: 'flex', gap: '0.25rem' }}>
                            <button style={{ padding: '0.5rem 0.75rem', border: '1px solid #e2e8f0', background: '#fff', borderRadius: '4px 0 0 4px', fontSize: '0.85rem', color: '#a0aec0', cursor: 'not-allowed' }}>Previous</button>
                            <button style={{ padding: '0.5rem 1rem', border: '1px solid #4a5568', background: '#4a5568', color: '#fff', fontSize: '0.85rem' }}>1</button>
                            <button style={{ padding: '0.5rem 0.75rem', border: '1px solid #e2e8f0', background: '#fff', borderRadius: '0 4px 4px 0', fontSize: '0.85rem', color: '#a0aec0', cursor: 'not-allowed' }}>Next</button>
                        </div>
                    </div>
                </div>

                {showAddModal && renderAddModal()}
            </div>

            {/* Tax Groups Section */}
            <div style={{ background: '#fff', borderRadius: '8px', border: '1px solid #e2e8f0', overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', marginTop: '1rem' }}>
                {/* Header Row */}
                <div style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid #e2e8f0', padding: '1.25rem' }}>
                    <h3 style={{ margin: 0, fontSize: '1rem', color: '#1e293b', fontWeight: '600' }}>All your tax groups</h3>
                    <button
                        onClick={() => setShowAddGroupModal(true)}
                        style={{ marginLeft: 'auto', background: '#4c00ff', color: 'white', border: 'none', borderRadius: '20px', padding: '0.5rem 1.5rem', fontWeight: '600', fontSize: '0.875rem', display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}
                    >
                        <Plus size={18} /> Add
                    </button>
                </div>

                <div style={{ padding: '1.5rem' }}>
                    {/* Controls Row */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem', flexWrap: 'wrap', gap: '1rem' }}>
                        <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                            <span style={{ fontSize: '0.9rem', color: '#64748b' }}>Show</span>
                            <select style={{ padding: '0.3rem 0.5rem', border: '1px solid #e2e8f0', borderRadius: '4px', fontSize: '0.85rem' }}>
                                <option>25</option>
                                <option>50</option>
                                <option>100</option>
                            </select>
                            <span style={{ fontSize: '0.9rem', color: '#64748b' }}>entries</span>
                        </div>

                        <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center', flexWrap: 'wrap' }}>
                            <div style={{ position: 'relative' }}>
                                <button
                                    onClick={() => setShowGroupExportDropdown(!showGroupExportDropdown)}
                                    style={{ background: '#fff', color: '#64748b', border: '1px solid #e2e8f0', padding: '0.5rem 1rem', borderRadius: '6px', display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.875rem', fontWeight: '600', cursor: 'pointer' }}
                                >
                                    <Download size={16} /> Export <ChevronDown size={14} />
                                </button>
                                {showGroupExportDropdown && (
                                    <div style={{ position: 'absolute', top: '100%', right: 0, marginTop: '0.5rem', background: '#fff', border: '1px solid #e2e8f0', borderRadius: '6px', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)', zIndex: 50, minWidth: '180px', padding: '0.5rem 0' }}>
                                        <button style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', width: '100%', padding: '0.6rem 1rem', border: 'none', background: 'none', textAlign: 'left', fontSize: '0.85rem', color: '#334155', cursor: 'pointer' }}>
                                            <FileSpreadsheet size={16} color="#10b981" /> Export CSV
                                        </button>
                                        <button style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', width: '100%', padding: '0.6rem 1rem', border: 'none', background: 'none', textAlign: 'left', fontSize: '0.85rem', color: '#334155', cursor: 'pointer' }}>
                                            <Printer size={16} color="#6366f1" /> Print
                                        </button>
                                        <button style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', width: '100%', padding: '0.6rem 1rem', border: 'none', background: 'none', textAlign: 'left', fontSize: '0.85rem', color: '#334155', cursor: 'pointer' }}>
                                            <FileText size={16} color="#ef4444" /> Export PDF
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                            <span style={{ fontSize: '0.9rem', color: '#64748b' }}>Search:</span>
                            <input
                                type="text"
                                value={groupSearchQuery}
                                onChange={(e) => setGroupSearchQuery(e.target.value)}
                                style={{ padding: '0.4rem 0.8rem', border: '1px solid #cbd5e1', borderRadius: '4px', fontSize: '0.85rem', outline: 'none' }}
                            />
                        </div>
                    </div>

                    {/* Table */}
                    <div style={{ overflowX: 'auto' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '0.9rem' }}>
                            <thead>
                                <tr style={{ borderTop: '1px solid #e2e8f0', borderBottom: '1px solid #e2e8f0' }}>
                                    <th style={{ padding: '1rem', color: '#1e293b', fontWeight: '700' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                            Name
                                            <div style={{ display: 'flex', flexDirection: 'column', fontSize: '10px' }}>▲▼</div>
                                        </div>
                                    </th>
                                    <th style={{ padding: '1rem', color: '#1e293b', fontWeight: '700' }}>Sub taxes</th>
                                    <th style={{ padding: '1rem', color: '#1e293b', fontWeight: '700' }}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {taxGroups.map((group) => (
                                    <tr key={group.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                                        <td style={{ padding: '1rem', color: '#4a5568' }}>{group.name}</td>
                                        <td style={{ padding: '1rem', color: '#4a5568' }}>{group.subTaxes}</td>
                                        <td style={{ padding: '0.75rem 1rem' }}>
                                            <div style={{ display: 'flex', gap: '0.5rem' }}>
                                                <button style={{ background: '#fff', color: '#6200ea', border: '1px solid #6200ea', padding: '0.3rem 0.8rem', borderRadius: '6px', fontSize: '0.8rem', display: 'flex', alignItems: 'center', gap: '0.3rem', fontWeight: '600', cursor: 'pointer' }}>
                                                    <Edit3 size={14} /> Edit
                                                </button>
                                                <button style={{ background: '#fff', color: '#ff5252', border: '1px solid #ff5252', padding: '0.3rem 0.8rem', borderRadius: '6px', fontSize: '0.8rem', display: 'flex', alignItems: 'center', gap: '0.3rem', fontWeight: '600', cursor: 'pointer' }}>
                                                    <Trash2 size={14} /> Delete
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                {showAddGroupModal && renderAddGroupModal()}
            </div>
        </div>
    );
};

export default TaxRates;
